"use client";

import { useEffect, useId, useState } from "react";
import type { ReactNode } from "react";
import ListingDirectoryFilter, {
  type ListingDirectoryFilterProps,
} from "@/components/bnp-ui/property-filter/listing-directory-filter";

interface Props {
  filter: ListingDirectoryFilterProps;
  children: ReactNode;
}

const OPEN_STORAGE_KEY = "listing-directory-filter-open";

export default function ListingDirectoryFilterDisclosure({
  filter,
  children,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();

  useEffect(() => {
    setIsOpen(window.sessionStorage.getItem(OPEN_STORAGE_KEY) === "true");
  }, []);

  const toggleFilter = () => {
    setIsOpen((open) => {
      const next = !open;
      window.sessionStorage.setItem(OPEN_STORAGE_KEY, String(next));
      return next;
    });
  };

  return (
    <div className="mb-8">
      <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-6">
        <div className="min-w-0 flex-1">{children}</div>
        <button
          type="button"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={toggleFilter}
          className="inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-lg bg-spec-brand px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-spec-brandHover active:scale-[0.98] md:w-auto"
        >
          Apply Filters
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-4 w-4"
            aria-hidden="true"
          >
            <path d="M4 5h16l-6.5 7.5V19l-3 1v-7.5L4 5Z" />
          </svg>
        </button>
      </div>

      {isOpen && (
        <div id={panelId} className="mt-5">
          <ListingDirectoryFilter {...filter} />
        </div>
      )}
    </div>
  );
}
